import { Loader2 } from 'lucide-react'
import type { HTMLAttributes } from 'react'
import { cn } from '~/lib/utils'

// 작은 인라인 스피너 — 버튼/리스트 로딩 표시용. 시맨틱 토큰만, 다크 자동 적응.
export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
    size?: 'sm' | 'md' | 'lg'
    /** 스크린리더용 라벨(시각적으론 숨김). 기본 '불러오는 중'. */
    label?: string
}

const SIZE_CLASSES: Record<NonNullable<SpinnerProps['size']>, string> = {
    sm: 'size-3.5',
    md: 'size-4',
    lg: 'size-5',
}

/** 미니멀 인라인 스피너. */
export function Spinner({
    className,
    size = 'md',
    label = '불러오는 중',
    ...props
}: SpinnerProps) {
    return (
        <span
            role='status'
            aria-live='polite'
            className={cn('text-muted-foreground inline-flex', className)}
            {...props}>
            <Loader2 className={cn('animate-spin', SIZE_CLASSES[size])} />
            <span className='sr-only'>{label}</span>
        </span>
    )
}
